import { NgModule } from "@angular/core";
import { CanMatchFn, Routes, RouterModule } from "@angular/router";

const paymentRoutePaths = new Set([
  "plans-and-payments",
  "payment-success",
  "payment-error",
]);

const paymentRoutesCanMatch: CanMatchFn = (_route, segments) =>
  paymentRoutePaths.has(segments[0]?.path);

const routes: Routes = [
  {
    path: "widgets",
    loadChildren: () =>
      import("./widget/widget.module").then((m) => m.WidgetModule),
  },

  {
    path: "mirrors",
    loadChildren: () =>
      import("./mirror/mirror.module").then((m) => m.MirrorModule),
  },

  {
    path: "user-profile",
    loadChildren: () =>
      import("./user-profile/user-profile.module").then(
        (m) => m.UserProfileModule
      ),
  },
  {
    path: "",
    canMatch: [paymentRoutesCanMatch],
    loadChildren: () =>
      import("./payment/payment.module").then((m) => m.PaymentModule),
  },
  {
    path: "edit-widget",
    loadComponent: () =>
      import("./shared/modals/widget-modal.component").then(
        (c) => c.WidgetModalComponent
      ),
  },
  {
    path: "display-view",
    loadComponent: () =>
      import("./shared/display-view/display-view.component").then(
        (c) => c.DisplayViewComponent
      ),
  },
  {
    path: "",
    loadChildren: () =>
      import("./authentication/authentication.module").then(
        (m) => m.AuthenticationModule
      ),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
